import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mockData';

export const Footer = ({ t }) => {
  return (
    <footer className="bg-brand-navy text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img
              src="/logo.png"
              alt="RajDarshan Tandon Dairy"
              className="h-16 w-auto mb-4 bg-white/10 p-2 rounded-lg"
            />
            <p className="text-white/80 font-semibold mb-2">{t.footerTagline}</p>
            <p className="text-white/60 text-sm">{t.footerDelivery}</p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold font-serif text-brand-pink mb-4">
              {t.footerAreas ? 'Reach Us' : 'Reach Us'}
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-brand-pink" />
                <a
                  href={`tel:+91${contactInfo.phone}`}
                  className="hover:text-brand-pink transition-colors font-semibold"
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-brand-pink" />
                <span>{t.footerAddress}</span>
              </div>
            </div>
          </div>

          {/* Quick Links — only real pages, no broken anchors */}
          <div>
            <h3 className="text-xl font-bold font-serif text-brand-pink mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-brand-pink transition-colors">
                  {t.home}
                </Link>
              </li>
              <li>
                <Link to="/milk-subscription-raipur" className="hover:text-brand-pink transition-colors font-semibold text-brand-pink/80">
                  {t.footerSubscription}
                </Link>
              </li>
              <li>
                <Link to="/pure-cow-buffalo-milk" className="hover:text-brand-pink transition-colors font-semibold text-brand-pink/80">
                  {t.footerQuality}
                </Link>
              </li>
              <li>
                <Link to="/raipur-delivery-areas" className="hover:text-brand-pink transition-colors font-semibold text-brand-pink/80">
                  {t.footerAreas}
                </Link>
              </li>
              <li>
                <Link to="/contact-dairy-raipur" className="hover:text-brand-pink transition-colors font-semibold text-brand-pink/80">
                  {t.footerContact}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-white/60 text-sm">{t.footerRights}</p>
        </div>
      </div>
    </footer>
  );
};
